<!-- 
  导出
 -->

 <template>
  <div class="get-template" v-if="moduleName==='workOrder'"> 
    <el-dialog title="选择模板" :visible.sync="dialogVisible">
      <el-form label-width="140px" class="custom-form">
        <el-form-item label="模板名称">
          <el-select v-model="temp" placeholder="请选择模板" v-if="options">
            <el-option v-for="item in options" :label="item.value" :value="item.key" :key="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
  <div class="get-template" v-else>
    <el-dialog title="选择模板" :visible.sync="dialogVisible">
      <el-form label-width="140px" class="custom-form">
        <el-form-item label="模板名称">
          <el-select v-model="temp" placeholder="请选择模板" v-if="options">
            <el-option v-for="item in options" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import * as common from 'src/config/common-config'
import { mapGetters } from 'vuex'

export default {
  created () {
    this.getTemplate()
  },
  props: {
    selectIds: {
      type: Array
    }
  },
  data () {
    return {
      dialogVisible: false,
      temp: '',
      options: [],
      // 文件导出类型
      exportType: common.exportMap
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ])
  },
  methods: {
    // 获取模板
    getTemplate () {
      if (this.moduleName === 'workOrder') {
        let url = `/workOrder/getTemplate.html`
        let params = {}
        api.post(url, params, (data) => {
          this.options = data.result
          this.temp = this.options.length ? this.options[0].key : 0
          if (this.options.length <= 1) {
            this.handleSubmit()
            return
          }
          this.dialogVisible = true
        })
      } else {
        let url = `/redundantTemplateApi/getTemplateList.html`
        let params = {
          type: this.exportType[this.moduleName]
        }
        api.post(url, params, (data) => {
          this.options = data.list
          this.temp = this.options.length ? this.options[0].id : 0
          // 如果仅有一个模板，则自动导出
          if (this.options.length <= 1) {
            this.handleSubmit()
            return
          }
          this.dialogVisible = true
        })
      }
    },
    // 提交
    handleSubmit () {
      this.$emit('export', this.temp)
      this.dialogVisible = false
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .get-template {
    .el-dialog--small {
      width: 600px;
    }
  }
</style>


// WEBPACK FOOTER //
// export.vue?2f9764c5